import React, { useContext } from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import Search from './Search';
import TrendingSearchData from './TrendingSearchData';
import { getAutocompleteSuggestions, getTrendingSearchData } from '../../../../queries';
import { ResizeContext } from '../../../../contexts/Resize/Resize';
import useGetGoogleRetailVisitorId from '../../../../hooks/useGetGoogleRetailVisitorId/useGetGoogleRetailVisitorId';

function SearchVM() {
  const { width } = useContext(ResizeContext);
  const { loading, error, data } = useQuery(getTrendingSearchData);
  const [
    getSuggestions,
    {
      data: suggestionsData,
      error: suggestionsError,
      loading: suggestionsLoading,
      variables,
    },
  ] = useLazyQuery(
    getAutocompleteSuggestions,
    {
      fetchPolicy: 'network-only',
    });


  const visitorId = useGetGoogleRetailVisitorId();
  const isGoogleRetailAutoCompleteEnabled = window?.FLAGS?.GoogleRetailAutoComplete ?? false;

  let searchData;
  if (loading || error) {
    searchData = TrendingSearchData;
  } else {
    searchData = data?.getTrendingSearches?.map(
      (trendingSearch) => ({ ...trendingSearch, category: 'trending-search' }),
    );
  }

  const buildAnalyticsURL = (attributionToken, search, values) => {
    let initialURL = `${values?.url}${values?.url?.includes('?') ? '&' : '?'}title=${values?.title}&category=${values?.category}`;
    if (search) {
      initialURL += `&input=${search}`;
    }
    if (typeof values.position === 'number') {
      initialURL += `&position=${values?.position}`;
    }
    if (attributionToken) {
      const urlWithToken = initialURL.concat(`&attributionToken=${attributionToken}`);
      return urlWithToken;
    }
    return initialURL;
  };

  const parseSuggestionsURL = (token, search, suggestions) => suggestions?.map((values) => ({
    ...values,
    url: buildAnalyticsURL(token, search, values),
  }));

  const parsedSearchData = isGoogleRetailAutoCompleteEnabled
    ? parseSuggestionsURL('', '', searchData)
    : searchData;

  let attributionToken = '';
  let suggestions;
  let parsedSuggestions;
  if (!suggestionsLoading && !suggestionsError) {
    const query = variables?.payload?.query;
    const autocompleteSuggestions = suggestionsData?.getAutocompleteSuggestions;
    attributionToken = autocompleteSuggestions?.attributionToken || '';
    suggestions = autocompleteSuggestions?.completionResults?.map((item) => ({
      category: 'autocomplete-suggestion',
      position: item.position,
      title: item.suggestion,
      url: `/exp/search?q=${item.suggestion}`,
    })).slice(0, 10);
    if (query && attributionToken && typeof (suggestions === 'Object')) {
      parsedSuggestions = parseSuggestionsURL(attributionToken, query, suggestions);
      const suggestionsString = JSON.stringify(parsedSuggestions);
      sessionStorage.setItem(query.toLowerCase(), suggestionsString);
      sessionStorage.setItem('lastSuggestions', suggestionsString);
    }
  }

  const mapProps = {
    attributionToken,
    data: parsedSearchData,
    visitorId,
    getSuggestions,
    isGoogleRetailAutoCompleteEnabled,
    suggestions: parsedSuggestions,
    suggestionsLoading,
    width,
  };

  return <Search {...mapProps} />;
}
export default SearchVM;
